module.exports = __webpack_public_path__ + "static/img/trailer-cover.e4900222.webp";